/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Member_ButtonInputs */



/**
* | output |
* | --- |
* | "Add member" |
*
* @param {Team_Manager_Add_Member_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_member_button = /** @type {((inputs?: Team_Manager_Add_Member_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Member_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un membre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglied hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi membro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить участника")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir miembro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メンバーを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्य जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar membro")
	return /** @type {LocalizedString} */ ("Add member")
});